import globals from '@descope-ui/theme-globals';
import { ComboBoxClass } from './component/ComboBoxClass';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import { refs } from '@descope-ui/theme-input-wrapper';

const globalRefs = getThemeRefs(globals);
const vars = ComboBoxClass.cssVarList;

export const comboBox = {
  [vars.hostWidth]: refs.width,
  [vars.hostDirection]: refs.direction,
  [vars.fontSize]: refs.fontSize,
  [vars.fontFamily]: refs.fontFamily,
  [vars.labelFontSize]: refs.labelFontSize,
  [vars.labelFontWeight]: refs.labelFontWeight,
  [vars.labelTextColor]: refs.labelTextColor,
  [vars.errorMessageTextColor]: refs.errorMessageTextColor,
  [vars.inputBorderColor]: refs.borderColor,
  [vars.inputBorderWidth]: refs.borderWidth,
  [vars.inputBorderStyle]: refs.borderStyle,
  [vars.inputBorderRadius]: refs.borderRadius,
  [vars.inputOutlineColor]: refs.outlineColor,
  [vars.inputOutlineOffset]: refs.outlineOffset,
  [vars.inputOutlineWidth]: refs.outlineWidth,
  [vars.inputOutlineStyle]: refs.outlineStyle,
  [vars.labelRequiredIndicator]: refs.requiredIndicator,
  [vars.inputValueTextColor]: refs.valueTextColor,
  [vars.inputPlaceholderTextColor]: refs.placeholderTextColor,
  [vars.inputBackgroundColor]: refs.backgroundColor,
  [vars.inputHorizontalPadding]: refs.horizontalPadding,
  [vars.inputHeight]: refs.inputHeight,
  [vars.inputDropdownButtonColor]: globalRefs.colors.surface.dark,
  [vars.inputDropdownButtonCursor]: 'pointer',
  [vars.inputDropdownButtonSize]: refs.toggleButtonSize,
  [vars.inputDropdownButtonOffset]: globalRefs.spacing.xs,
  [vars.overlayItemPaddingInlineStart]: globalRefs.spacing.xs,
  [vars.overlayItemPaddingInlineEnd]: globalRefs.spacing.lg,
  [vars.labelPosition]: refs.labelPosition,
  [vars.labelTopPosition]: refs.labelTopPosition,
  [vars.labelHorizontalPosition]: refs.labelHorizontalPosition,
  [vars.inputTransformY]: refs.inputTransformY,
  [vars.inputTransition]: refs.inputTransition,
  [vars.marginInlineStart]: refs.marginInlineStart,
  [vars.placeholderOpacity]: refs.placeholderOpacity,
  [vars.inputVerticalAlignment]: refs.inputVerticalAlignment,
  [vars.valueInputHeight]: refs.valueInputHeight,
  [vars.valueInputMarginBottom]: refs.valueInputMarginBottom,

  // error message icon
  [vars.errorMessageIcon]: refs.errorMessageIcon,
  [vars.errorMessageIconSize]: refs.errorMessageIconSize,
  [vars.errorMessageIconPadding]: refs.errorMessageIconPadding,
  [vars.errorMessageIconRepeat]: refs.errorMessageIconRepeat,
  [vars.errorMessageIconPosition]: refs.errorMessageIconPosition,
  [vars.errorMessageFontSize]: refs.errorMessageFontSize,

  _readonly: {
    [vars.inputDropdownButtonCursor]: 'default',
  },

  // Overlay theme exposed via the component:
  [vars.overlayFontSize]: refs.fontSize,
  [vars.overlayFontFamily]: refs.fontFamily,
  [vars.overlayCursor]: 'pointer',
  [vars.overlayItemBoxShadow]: 'none',
  [vars.overlayBackground]: refs.backgroundColor,
  [vars.overlayTextColor]: refs.valueTextColor,
  [vars.overlayCheckmarkDisplay]: 'initial',
  [vars.overlaySelectedItemBackground]: 'initial',
  [vars.overlaySelectedItemHoverBackground]:
    globalRefs.colors.primary.highlight,
  [vars.overlaySelectedItemFocusBackground]:
    globalRefs.colors.primary.highlight,
  [vars.overlayItemHoverBackground]: globalRefs.colors.primary.highlight,
  [vars.overlayItemFocusBackground]: globalRefs.colors.primary.highlight,

  // Overlay direct theme:
  [vars.overlay.minHeight]: '400px',
  [vars.overlay.margin]: '0',

  [vars.overlay.contentHeight]: '100%',
  [vars.overlay.contentOpacity]: '1',
  [vars.overlay.scrollerMinHeight]: '1px',
  _loading: {
    [vars.overlay.loaderTop]: '50%',
    [vars.overlay.loaderLeft]: '50%',
    [vars.overlay.loaderRight]: 'auto',
    // Margin has to be negative to center the loader, "transform" can't be used because the animation uses it
    // Margin has to be half of the width/height of the loader to center it
    [vars.overlay.loaderMargin]: '-15px 0 0 -15px',
    [vars.overlay.loaderWidth]: '30px',
    [vars.overlay.loaderHeight]: '30px',
    [vars.overlay.loaderBorder]: '2px solid transparent',
    [vars.overlay.loaderBorderColor]:
      `${globalRefs.colors.primary.highlight} ${globalRefs.colors.primary.highlight} ${globalRefs.colors.primary.main} ${globalRefs.colors.primary.main}`,
    [vars.overlay.loaderBorderRadius]: '50%',
    [vars.overlay.contentHeight]: '100px',
    [vars.overlay.scrollerMinHeight]: '100px',
    [vars.overlay.contentOpacity]: '0',
  },
};

export default comboBox;
export { vars };
